import * as React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

interface IProps {
    isVisible?: boolean;
}

export function LoadingBar(
    { isVisible }: IProps = { isVisible: false },
): JSX.Element {
    return (
        <div
            className={cn({
                [styles.wrapper]: true,
                [styles.wrapperVisible]: isVisible,
            })}
        />
    );
}
